import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAdminHeaders, clearAdminSession, validateAdminSession } from '../../utils/adminAuth';
import './SettingsPage.css';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

const ChangePasswordPage: React.FC = () => {
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (newPassword.length < 8) {
      setError('Password must be at least 8 characters');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    setIsLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}/admin/change-password`, {
        method: 'POST',
        headers: getAdminHeaders(),
        body: JSON.stringify({ newPassword }),
      });
      const data = await response.json();
      if (!response.ok || !data.success) {
        setError(data.message || 'Failed to update password');
        return;
      }
      await validateAdminSession();
      navigate('/admin-panel');
    } catch {
      setError('Failed to connect to server');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="settings-container">
      <div className="settings-card" style={{ maxWidth: 480 }}>
        <div className="settings-header">
          <h1 className="settings-title">Set Your Password</h1>
          <p className="settings-subtitle">
            You must choose a new password before using the admin panel.
          </p>
        </div>
        <form onSubmit={handleSubmit} className="access-form">
          {error && <div className="access-error">{error}</div>}
          <label>
            New password
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              disabled={isLoading}
              required
              minLength={8}
            />
          </label>
          <label>
            Confirm password
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              disabled={isLoading}
              required
              minLength={8}
            />
          </label>
          <button type="submit" className="access-primary-btn" disabled={isLoading}>
            {isLoading ? 'Saving...' : 'Save password'}
          </button>
          <button
            type="button"
            className="back-button"
            onClick={() => {
              clearAdminSession();
              navigate('/admin-login');
            }}
          >
            Cancel / Logout
          </button>
        </form>
      </div>
    </div>
  );
};

export default ChangePasswordPage;
